module.exports = __webpack_public_path__ + "static/media/second-slide.c5fdc3d3.webp";